import { safeStorage } from './safeStorage'

// ── Pending-room carry-through ────────────────────────────────────────────────
// Co-watch is the hero feature, but a Viewing Room was inert without a second
// person already in the app. A "/join/:roomId" link now drops anyone — including a
// brand-new user — straight into the room. A logged-out recipient goes
// join → login → lands back in the app on "/", not on the join route, so we persist
// the target room across the signup + magic-link round-trip (same-browser via
// storage, cross-device via the ?join_room= redirect param) and a boot-time resolver
// hops them into the room once a session exists. Mirrors pendingInvite exactly.
const KEY = 'nextep_pending_room'
// Short validity window: someone who opens a room link, abandons signup, then signs
// in normally hours later must NOT get yanked into a stale (likely-ended) room.
const TTL_MS = 60 * 60 * 1000  // 1 hour

// Read a pending room from the URL (?join_room=ROOMID&jr_show=SHOWID, survives
// cross-device magic links) or from storage (survives the same-browser signup hop,
// with a freshness TTL). Returns { roomId, showId } or null.
export function readPendingRoom() {
  try {
    const q = new URLSearchParams(window.location.search)
    const roomId = q.get('join_room')
    if (roomId) return { roomId, showId: q.get('jr_show') || null }  // fresh from a redirect, no TTL
  } catch { /* no window/search */ }
  const raw = safeStorage.get(KEY)
  if (!raw) return null
  try {
    const { r, s, t } = JSON.parse(raw)
    if (!r || (t && Date.now() - t > TTL_MS)) { safeStorage.remove(KEY); return null }
    return { roomId: r, showId: s || null }
  } catch {
    safeStorage.remove(KEY); return null
  }
}

export function stashPendingRoom(roomId, showId = null) {
  if (!roomId) return
  try { safeStorage.set(KEY, JSON.stringify({ r: String(roomId), s: showId ? String(showId) : null, t: Date.now() })) } catch { /* storage blocked */ }
}

export function clearPendingRoom() {
  safeStorage.remove(KEY)
  // Strip ?join_room=/?jr_show= from the URL so a refresh / re-mount can't re-trigger the hop.
  try {
    const url = new URL(window.location.href)
    let touched = false
    for (const p of ['join_room', 'jr_show']) {
      if (url.searchParams.has(p)) { url.searchParams.delete(p); touched = true }
    }
    if (touched) window.history.replaceState(null, '', url.pathname + url.search + url.hash)
  } catch { /* no window */ }
}
